module.exports = __webpack_public_path__ + "img/chanzidamowang.6328c290.png";